import { env } from './env';
import { ApiError, describeError } from './errors';

/**
 * Public RPC over plain fetch with the anon key. Every privileged decision
 * (tenant, prices, slots, limits) is made by SQL functions on the server.
 * Owner code uses the authenticated `rpc` from `@/lib/supabase` instead.
 */
export async function rpc<T>(fn: string, args: Record<string, unknown>): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${env.supabaseUrl}/rest/v1/rpc/${fn}`, {
      method: 'POST',
      headers: { apikey: env.supabaseAnonKey, authorization: `Bearer ${env.supabaseAnonKey}`, 'content-type': 'application/json' },
      body: JSON.stringify(args),
    });
  } catch {
    throw new ApiError('Failed to fetch', describeError('Failed to fetch'));
  }
  const body = (res.status === 204 ? null : await res.json().catch(() => null)) as { message?: string; code?: string; hint?: string | null } | null;
  if (!res.ok) {
    const code = body?.message || body?.code || 'unknown_error';
    throw new ApiError(code, describeError(code, body?.hint), res.status);
  }
  return body as T;
}
